import { render, staticRenderFns } from "./HashtagsAddNew.vue?vue&type=template&id=ffe20fd0&"
import script from "./HashtagsAddNew.vue?vue&type=script&lang=js&"
export * from "./HashtagsAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports